import { render, staticRenderFns } from "./ManageOrgProfile.vue?vue&type=template&id=7c959c7d&"
import script from "./ManageOrgProfile.vue?vue&type=script&lang=js&"
export * from "./ManageOrgProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports